import { CustomNote } from "types/customNote"
import { create } from "zustand"

export const useCustomNote = create<CustomNote>((set) => ({
  customNote: "",
  customNoteChange: (customNote: string) =>
    set(() => ({ customNote: customNote })),
}))
